import * as React from 'react';

import { Dialog } from '@longline/aqua-ui/services/Dialog';

import { ISpecies } from '../../api/models/ISpecies';
import { SpeciesContext } from './ISpeciesContext';
import { SpeciesPane } from './SpeciesPane';
import { SpeciesApi } from '../../api/services/SpeciesApi';
import { TManagerMode } from '../../types/TManagerMode';

const SpeciesManager = () => {
  // Hydration state. While hydrating: `true`. Once finished: the uuid string
  // of the most-recently-hydrated species. Null at startup.
  const [hydrating, setHydrating] = React.useState<string | boolean | null>(null);
  // Species selected in list:
  const [species, _setSpecies] = React.useState<ISpecies | null>(null);
  // Pane mode:
  const [mode, setMode] = React.useState<TManagerMode>('list');
  // Current error:
  const [error, setError] = React.useState<any>(null);

  /**
   * Sets current species. Loads species details from backend first.
   */
  const setSpecies = (species: ISpecies): void => {
    _setSpecies(species);

    // hydrate(species, SpeciesApi.get, setHydrating);
    // Item already hydrated? Abort.
    if(species.hydrated) return;    

    setHydrating(true);
    SpeciesApi.get(species.uuid)
    .then(data => {
      Object.assign(species, { ...data, hydrated: true });
    })
    .catch(_ => {})
    .finally(() => {
      setHydrating(species.uuid);
    });
  }

  return (
    <SpeciesContext.Provider value={{
      hydrating,
      mode,
      setMode,
      species,
      setSpecies,
    }}>
      <SpeciesPane/>
      <Dialog.Xhr error={error} open={error != null} onClose={() => setError(null)}/>
    </SpeciesContext.Provider>
  )
}

export { SpeciesManager }
